import { brands } from '@/config/brands';

/** Payment platform / processor product name — never the CRM partner white-label. */
export const TAGADAPAY_PLATFORM_NAME = brands.tagadapay.appName;
